module.exports = __webpack_public_path__ + "5a1e97305e05434652178f7ad90071cb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/sign.svg
// module id = 781
// module chunks = 0